import {
  COURSE_STATUS_APPROVED,
  COURSE_STATUS_PENDING,
  COURSE_STATUS_REJECTED,
  COURSE_STATUS_APPROVED_NAME,
  COURSE_STATUS_PENDING_NAME,
  COURSE_STATUS_REJECTED_NAME,
} from 'Constants/General';
import type { DashboardCourseI, MyCourseStatusFilterT } from 'types';

export const STATUS_BY_FILTER: Record<MyCourseStatusFilterT, { id: string; name: string }> = {
  pending: { id: COURSE_STATUS_PENDING, name: COURSE_STATUS_PENDING_NAME },
  approved: { id: COURSE_STATUS_APPROVED, name: COURSE_STATUS_APPROVED_NAME },
  failed: { id: COURSE_STATUS_REJECTED, name: COURSE_STATUS_REJECTED_NAME },
};

// Tupla posicional que espera src/Pages/CourseDetails/index.js en
// location.state.course — mismo orden que el mapCourses legacy de MyCourses.
// course[6] debe ser el key S3 (Dates lo re-pasa a asistencia), no la URL firmada.
const mapCourseToRouteState = (course: DashboardCourseI) => [
  course.title,
  course.description,
  course.priority?.name,
  course.category?.name,
  course.creator?.fullName,
  course.creator?.photo,
  course.thumbnailKey,
  course.updatedAt,
  course.isDraft,
  course.expirationDate,
  course.id,
  STATUS_BY_FILTER[course.status],
];

export default mapCourseToRouteState;
